import type { Field } from "@components/FieldList";

/** `item_mp_id` -> `Item mp ID`. */
export function humanizeKey(key: string): string {
  return key
    .replace(/_/g, " ")
    .replace(/\bid\b/gi, "ID")
    .replace(/^\w/, (c) => c.toUpperCase());
}

function isEmpty(value: unknown): boolean {
  return value === null || value === undefined || value === "";
}

function formatValue(value: unknown): string {
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

/** A hit's metadata as fields: empty values and `omit` keys skipped, sorted by key. */
export function metadataFields(metadata: Record<string, unknown>, omit: readonly string[] = []): Field[] {
  const skip = new Set(omit);
  return Object.entries(metadata)
    .filter(([key, value]) => !skip.has(key) && !isEmpty(value))
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([key, value]) => [humanizeKey(key), formatValue(value)] as const);
}
